import axios from "axios";

const axiosAuth = axios.create({
  baseURL: "https://hitmeup-backend.fly.dev", // <-- Make sure this matches your backend port
  withCredentials: true, // Enable credentials for cross-origin requests
  // ...other config
});

axiosAuth.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosAuth;